import React, { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloud } from '@fortawesome/free-solid-svg-icons'
import { faSun } from '@fortawesome/free-solid-svg-icons'
import { faCloudShowersHeavy } from '@fortawesome/free-solid-svg-icons'
import { faCloudBolt } from '@fortawesome/free-solid-svg-icons'
import { faSnowflake } from '@fortawesome/free-solid-svg-icons'
import { faCloudRain } from '@fortawesome/free-solid-svg-icons'
import { faSmog } from '@fortawesome/free-solid-svg-icons'

const Icon = ({condition}) => {
    if(condition=='Clear'){
        return(
            <div className="icon">
            <FontAwesomeIcon className="sun" icon={faSun} size="7x"/>
            </div>
        )
    }
    else if(condition=='Clouds'){
        return(
            <div className="icon">
            <FontAwesomeIcon className="cloud"  icon={faCloud} size="7x"/>
            </div>
        )
    }
    else if(condition=='Rain'){
        return(
            <div className="icon">
            <FontAwesomeIcon className="rain"  icon={faCloudShowersHeavy} size="7x"/>
            </div>
        )
    }
    else if(condition=='Snow'){
        return(
            <div className="icon">
            <FontAwesomeIcon className="snow"  icon={faSnowflake} size="7x"/>
            </div>
        )
    }
    else if(condition=='Drizzle'){
        return(
            <div className="icon">
            <FontAwesomeIcon className="rain"  icon={faCloudRain} size="7x"/>
            </div>
        )
    }
    else if(condition=='Thunderstorm'){
        return(
            <div className="icon">
            <FontAwesomeIcon className="bolt"  icon={faCloudBolt} size="7x"/>
            </div>
        )
    }
    else{
        return(
            <div className="icon">
            <FontAwesomeIcon className="rain"  icon={faSmog} size="7x"/>
            </div>
        )
    }
    
}


export default Icon